import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export default function TrialExpired() {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <div className="min-h-screen bg-[#F5F4F0] flex items-center justify-center px-6" data-testid="trial-expired-page">
      <div className="max-w-xl w-full bg-white border border-black/10 rounded-lg p-10 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-100 text-red-700 mb-6">
          <AlertTriangle size={24} />
        </div>
        <h1 className="font-serif text-3xl tracking-tighter">Your free trial has ended</h1>
        <p className="text-sm text-zinc-600 mt-3">
          Pick a plan to continue managing your bookings, invoices and clients in EventFlow.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          {isAdmin ? (
            <Link to="/app/subscription">
              <Button className="bg-[#D85C38] hover:bg-[#B84A2A] text-white rounded-full px-6 h-11" data-testid="trial-expired-subscribe-btn">
                Pick a plan <ArrowRight size={14} className="ml-2" />
              </Button>
            </Link>
          ) : (
            <div className="text-sm text-zinc-600 max-w-sm">
              Please ask your workspace admin to renew the subscription. Only the admin can manage billing.
            </div>
          )}
          <Button variant="ghost" onClick={() => logout()} data-testid="trial-expired-logout-btn">Sign out</Button>
        </div>
      </div>
    </div>
  );
}
